import "core-js/modules/es6.object.create";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';

var TabContent =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TabContent, _React$Component);

  function TabContent() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = TabContent.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        hasIframe = _this$props.hasIframe,
        children = _this$props.children;
    return React.createElement("div", {
      className: "tab-content" + (hasIframe ? ' iframe' : '')
    }, children);
  };

  return TabContent;
}(React.Component);

export default TabContent;